module.exports = __webpack_public_path__ + "static/media/teeny.8a2674cf.ico";